import { Component, ViewEncapsulation } from '@angular/core';
import { Configuration } from '../../../configuration';

@Component({
    selector: 'basic',
    template: require('./basic.component.html'),
    styles: [require('./basic.component.css'), require('./environment.banner.css')],
    encapsulation: ViewEncapsulation.None
})
export class BasicComponent {
    constructor(public configuration: Configuration) { }

    public notificationOptions = {
        position: ['top', 'right'],
        timeOut: 3000
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/components/common/layouts/basic.component.ts